<!--loading-->
<div *ngIf="loading" class="m-5">
  <div class="container">
    <div class="row justify-content-center">
      <span class="k-icon k-i-loading kendo-loading-icon"></span>
    </div>
  </div>
</div>
<div class="scroll" *ngIf="!loading && userForm">
  <form [formGroup]="userForm" class="k-form" style="margin-top:-8px">
    <kendo-tabstrip #tabstrip (tabSelect)="onTabSelect($event)">
      <kendo-tabstrip-tab title="{{ 'USER' | translate }}" [selected]="true">
        <ng-template kendoTabContent>
          <div class="p-3">
            <div class="row" *ngIf="!servicesAccount.value">
              <div [ngClass]="{'col-sm-12 col-md-8': !isCommunityUserRole, 'col': isCommunityUserRole}">
                <div class="row">
                  <div class="col-6">
                    <label class="k-form-field mt-0">
                      <span class="k-text-uppercase dark">
                        {{'FIRST-NAME' | translate}} *
                      </span>
                      <input id="firstName" kendoTextBox formControlName="firstName" maxlength="30" />
                      <div class="k-tooltip k-tooltip-validation" role="alert"
                        *ngIf="firstName.hasError('required') && firstName.touched">
                        {{'REQUIRED-FIRST-NAME' | translate}}
                      </div>
                    </label>
                  </div>
                  <div class="col-6">
                    <label class="k-form-field mt-0">
                      <span class="k-text-uppercase dark">
                        {{'LAST-NAME' | translate}} *
                      </span>
                      <input id="lastName" kendoTextBox formControlName="lastName" maxlength="30" />
                      <div class="k-tooltip k-tooltip-validation" role="alert"
                        *ngIf="lastName.hasError('required') && lastName.touched">
                        {{'REQUIRED-LAST-NAME' | translate}}
                      </div>
                    </label>
                  </div>
                </div>
                <div class="row" *ngIf="!servicesAccount.value">
                  <div class="col-6">
                    <label class="k-form-field mt-0">
                      <span class="k-text-uppercase dark">
                        <i class="fas fa-envelope fa-fw"></i> {{'EMAIL' | translate}} *
                      </span>
                      <input id="email" kendoTextBox formControlName="email" email maxlength="255" />
                      <div class="k-tooltip k-tooltip-validation" role="alert"
                        *ngIf="email.hasError('required') && email.touched">
                        {{'REQUIRED-EMAIL' | translate}}
                      </div>
                      <div class="k-tooltip k-tooltip-validation" role="alert" *ngIf="email.hasError('emailTaken')">
                        {{'EMAIL-ALREADY-REGISTERED' | translate}}
                      </div>
                    </label>
                  </div>
                  <div class="col-6">
                    <label class="k-form-field mt-0">
                      <span class="k-text-uppercase dark" *ngIf="isCommunityUserRole && !isPhoneRequired">
                        <i class="fas fa-mobile-alt fa-fw"></i> {{'CELL-PHONE' | translate}}
                      </span>
                      <span class="k-text-uppercase dark" *ngIf="isCommunityUserRole && isPhoneRequired">
                        <i class="fas fa-mobile-alt fa-fw"></i> {{'CELL-PHONE' | translate}} *
                      </span>
                      <span class="k-text-uppercase dark" *ngIf="!isCommunityUserRole">
                        <i class="fas fa-phone fa-fw"></i> {{'PHONE' | translate}}
                      </span>
                      <kendo-maskedtextbox [mask]="phoneNumberMask" id="phoneNumber" formControlName="phoneNumber">
                      </kendo-maskedtextbox>
                      <div class="k-tooltip k-tooltip-validation" role="alert"
                        *ngIf="phoneNumber.hasError('required') && phoneNumber.touched">
                        {{'REQUIRED-PHONE' | translate}}
                      </div>
                    </label>
                  </div>
                </div>
                <div class="row">
                  <div class="col-6" *ngIf="!servicesAccount.value">
                    <label class="k-form-field mt-0">
                      <span class="k-text-uppercase dark">
                        {{'NOTIFICATION-LANGUAGE' | translate}}
                      </span>
                      <kendo-combobox formControlName="preferredLanguage" [data]="preferredLanguages"
                        [textField]="'text'" [valueField]="'value'" [valuePrimitive]="true">
                      </kendo-combobox>
                    </label>
                  </div>
                </div>
              </div>
              <div class="col-sm-12 col-md-4" style="min-width:300px;" *ngIf="!isCommunityUserRole">
                <label class="k-form-field mb-0 mt-0">
                  <span class="k-text-uppercase dark">
                    {{'PHOTO' | translate}}
                  </span>
                </label>
                <kendo-upload formControlName="photo" #kendoUploader [autoUpload]="false" [multiple]="false"
                  [restrictions]="imageRestrictions" (select)="setUserImage($event)">
                  <kendo-upload-messages select="{{'SELECT-PHOTO' | translate}}"></kendo-upload-messages>
                </kendo-upload>
                <div class="photo-container">
                  <img alt="{{'PHOTO' | translate}}" [src]="imageToShow" *ngIf="!isImageLoading && imageToShow"
                    (click)="selectPhoto()" role="button" tabindex="0" (keydown.enter)="selectPhoto()"
                    (keydown.space)="selectPhoto()" class="keyboard-accessible">
                </div>
                <i *ngIf="!isImageLoading && (isNewImageSelected || photo.value !== null)"
                  class="fas fa-trash-alt fa-lg float-right mt-2" title="{{'DELETE' | translate}}"
                  (click)="deleteImage()" style="position:absolute;bottom:15px;right:25px;"
                  attr.aria-label="{{'DELETE' | translate}}" role="button" tabindex="0" (keydown.enter)="deleteImage()"
                  (keydown.space)="deleteImage()"></i>
              </div>
            </div>
            <div class="row mt-2" *ngIf="!servicesAccount.value && !isCommunityUserRole">
              <div class="col">
                <label class="k-form-field mt-0">
                  <span class="k-text-uppercase dark">
                    {{'ORGANIZATION' | translate}} *
                  </span>
                  <kendo-combobox id="organization" formControlName="organization" class="w-100"
                    [valuePrimitive]="false" [itemDisabled]="itemDisabled" [data]="organizations" [textField]="'name'"
                    [valueField]="'id'" (valueChange)="handleOrganizationChange($event)"
                    [readonly]="isCommunityAdmin || isReferralCoordinator || isProgramLeadRole">
                  </kendo-combobox>
                  <div class="k-tooltip k-tooltip-validation" role="alert"
                    *ngIf="organization.hasError('required') && organization.touched">
                    {{'REQUIRED-ORGANIZATION' | translate}}
                  </div>
                </label>
              </div>
              <div class="col">
                <label class="k-form-field mt-0">
                  <span class="k-text-uppercase dark">
                    {{'DEPARTMENT' | translate}}
                  </span>
                  <kendo-combobox id="department" formControlName="department" class="w-100" [valuePrimitive]="false"
                    [itemDisabled]="itemDisabled" [data]="resultDepartments" [textField]="'name'" [valueField]="'id'">
                  </kendo-combobox>
                </label>
              </div>
            </div>
            <div class="row">
              <div class="col-6">
                <label for="role" class="k-form-field mt-0" [ngClass]="{'mt-2': isCommunityUserRole}">
                  <span class="k-text-uppercase dark">
                    {{'USER-ROLE' | translate}} *&nbsp;<span style="display: inline-flex">
                      <div kendoTooltip [tooltipTemplate]="roleInfoTemplate" position="right" aria-live="polite"
                        class="keyboard-accessible" tabindex="0" showOn="none" (focus)="showTooltip(roleTooltip)"
                        (mouseover)="showTooltip(roleTooltip)" (blur)="hideTooltip()" (mouseout)="hideTooltip()">
                        <i #roleTooltip title="" class="fa fa-info-circle pointer" role="button"
                          attr.aria-label="{{'USER-ROLE' | translate}}"></i>
                      </div>
                    </span>
                  </span>
                  <kendo-combobox #userRole formControlName="role" [data]="roles" [textField]="'text'"
                    [valueField]="'value'" [valuePrimitive]="true">
                  </kendo-combobox>
                  <div class="k-tooltip k-tooltip-validation" role="alert"
                    *ngIf="role.hasError('required') && role.touched">
                    {{'REQUIRED-USER-ROLE' | translate}}
                  </div>
                </label>
              </div>
              <div class="col-6" *ngIf="!servicesAccount.value && !isCommunityUserRole">
                <label for="role" class="k-form-field mt-0">
                  <span class="k-text-uppercase dark">
                    {{'ACTIVE-ROLES' | translate}}
                  </span>
                  <kendo-multiselect #activeUserRoles [data]="activeRoles" [valuePrimitive]="true"
                    formControlName="allowedRoles" [textField]="'text'" [valueField]="'value'">
                  </kendo-multiselect>
                </label>
              </div>
              <div class="col-6" *ngIf="kno2Enabled && !servicesAccount.value && !isCommunityUserRole">
                <label class="k-form-field mt-2">
                  <span class="k-text-uppercase dark">
                    <i class="fas fa-at fa-fw"></i> {{'DIRECT-ADDRESS' | translate}}
                  </span>
                  <kendo-combobox id="directAddress" formControlName="directAddress" class="w-100"
                    [valuePrimitive]="true" [data]="kno2DocumentSources" [textField]="'fullAddress'"
                    [valueField]="'fullAddress'">
                    <ng-template kendoComboBoxItemTemplate let-dataItem>
                      <span class="ellipsis-text" title="{{dataItem.fullAddress}}">{{dataItem.fullAddress}}</span>
                    </ng-template>
                  </kendo-combobox>
                  <div class="k-tooltip k-tooltip-validation" role="alert"
                    *ngIf="directAddress.hasError('directAddressTaken')">
                    {{'DIRECT-ADDRESS-ALREADY-REGISTERED' | translate}}
                  </div>
                </label>
              </div>
              <div
                [ngClass]="{'col-6': kno2Enabled && !servicesAccount.value && !isCommunityUserRole, 'col-12': !(kno2Enabled && !servicesAccount.value && !isCommunityUserRole)}">
                <label class="k-form-field">
                  <span class="k-text-uppercase dark">
                    {{'NOTES' | translate}}
                  </span>
                  <textarea id="note" kendoTextArea rows="1" formControlName="note" class="w-100" maxlength="4000"
                    style="min-height:38px;">
                  </textarea>
                </label>
              </div>
            </div>
            <div class="row" *ngIf="registrationType.value === 'password'">
              <div class="col">
                <label class="k-form-field mt-0">
                  <span class="k-text-uppercase dark">
                    {{'USERNAME' | translate}} *
                  </span>
                  <input id="username" kendoTextBox formControlName="username" maxlength="{{maxUsernameLength}}"
                    autocomplete="off" />
                  <div class="k-tooltip k-tooltip-validation" role="alert"
                    *ngIf="username.hasError('required') && username.touched">
                    {{'REQUIRED-USERNAME' | translate}}
                  </div>
                  <div class="k-tooltip k-tooltip-validation" role="alert"
                    *ngIf="username.hasError('minlength') && username.touched">
                    <span translate [translateParams]="{value: minUsernameLength}">{{'USERNAME-MIN-LENGTH'}}</span>
                  </div>
                  <div class="k-tooltip k-tooltip-validation" role="alert"
                    *ngIf="username.hasError('pattern') && !username.hasError('minlength') && username.touched">
                    {{'USERNAME-INVALID-PATTERN' | translate}}
                  </div>
                  <div class="k-tooltip k-tooltip-validation" role="alert" *ngIf="username.hasError('usernameTaken')">
                    {{'USERNAME-ALREADY-EXISTS' | translate}}
                  </div>
                </label>
              </div>
              <div class="col">
                <label class="k-form-field mt-0">
                  <span class="k-text-uppercase dark">
                    {{'PASSWORD' | translate}}<span *ngIf="isPasswordRequired"> *</span>
                  </span>
                  <input id="password" type="password" kendoTextBox formControlName="password"
                    maxlength="{{servicesAccount.value ? maxPasswordLengthService : maxPasswordLength}}"
                    autocomplete="new-password" />
                  <div class="k-tooltip k-tooltip-validation" role="alert"
                    *ngIf="password.hasError('required') && password.touched">
                    {{'REQUIRED-PASSWORD' | translate}}
                  </div>
                  <div class="k-tooltip k-tooltip-validation" role="alert"
                    *ngIf="password.hasError('minlength') && password.touched">
                    <span translate
                      [translateParams]="{value: servicesAccount.value ? minPasswordLengthService : minPasswordLength}">{{'PASSWORD-MIN-LENGTH'}}
                    </span>
                  </div>
                  <div class="k-tooltip k-tooltip-validation" role="alert"
                    *ngIf="password.hasError('pattern') && !password.hasError('minlength') && password.touched">
                    {{invalidPasswordText}}
                  </div>
                  <password-strength-meter *ngIf="password.value" [password]="password.value"
                    [colors]="passwordMeterColors">
                  </password-strength-meter>
                </label>
              </div>
            </div>
            <div class="row mt-2">
              <div class="col-6">
                <div class="row">
                  <div class="col-6 pr-0" *ngIf="isAdmin && !isCommunityUserRole">
                    <label class="k-text-uppercase dark mr-2" for="servicesAccount">{{ 'SERVICES-ACCOUNT' | translate }}
                      <kendo-switch formControlName="servicesAccount" onLabel="{{'YES' | translate }}"
                        offLabel="{{'NO' | translate }}">
                      </kendo-switch>
                    </label>
                  </div>
                  <div class="col-6 pr-0" *ngIf="isAdmin && !servicesAccount.value && !isCommunityUserRole">
                    <label class="k-text-uppercase dark mr-2" for="enabled">{{ 'EHR-ONLY-ACCESS' | translate }}
                      <kendo-switch formControlName="ehrOnlyAccess" onLabel="{{'YES' | translate }}"
                        offLabel="{{'NO' | translate }}">
                      </kendo-switch>
                    </label>
                  </div>
                </div>
              </div>
              <div class="col-6" *ngIf="!isCommunityUserRole && isRegistrationTypeVisible">
                <label class="k-text-uppercase dark mr-2">
                  {{'REGISTRATION-TYPE' | translate}}
                </label>
                <br />
                <input type="radio" value="password" name="registrationType" formControlName="registrationType" checked
                  id="radioPassword" kendoRadioButton />
                <label class="k-radio-label" for="radioPassword"
                  [ngClass]="{'k-disabled': registrationType.disabled}">{{'ENTER-PASSWORD' | translate}}</label>
                <input type="radio" value="registration" name="registrationType" formControlName="registrationType"
                  class=" ml-0" checked id="radioRegistration" kendoRadioButton />
                <label class="k-radio-label" for="radioRegistration"
                  [ngClass]="{'k-disabled': registrationType.disabled}">{{'SEND-REGISTRATION' | translate}}</label>
              </div>
            </div>
            <div class="row mt-2">
              <div class="col-6" *ngIf="!servicesAccount.value">
                <label class="k-text-uppercase dark mr-2" for="twoFa">{{ 'TWO-FACTOR-AUTH' | translate }}
                  <kendo-switch formControlName="twoFa" onLabel="{{'YES' | translate }}"
                    offLabel="{{'NO' | translate }}">
                  </kendo-switch>
                  <a *ngIf="!isCommunityUserRole && twoFa.value && !userForm.dirty && !isNew" class="pointer ml-4"
                    (click)="openQRCodeDialog();">
                    <i class="fas fa-qrcode icon-info mr-1"></i>{{'DISPLAY-QRCODE' | translate}}
                  </a>
                </label>
              </div>
              <div class="col-6 pr-0" *ngIf="isAdmin">
                <label class="k-text-uppercase dark mr-2" for="enabled">{{ 'ACCOUNT-ENABLED' | translate }}
                  <kendo-switch formControlName="enabled" onLabel="{{'YES' | translate }}"
                    offLabel="{{'NO' | translate }}">
                  </kendo-switch>
                </label>
              </div>
            </div>
          </div>
          <div [ngClass]="{'ml-2': !isAdmin}">* {{'REQUIRED-FIELDS' | translate}}</div>
        </ng-template>
      </kendo-tabstrip-tab>
      <kendo-tabstrip-tab title="{{ 'ISSUERS' | translate }}"
        *ngIf="!isNew && !servicesAccount.value && selectedUser.userIssuers.length > 0">
        <ng-template kendoTabContent>
          <div class="mt-2 mb-2">
            <kendo-grid [data]="selectedUser.userIssuers" [pageable]="false" style="max-height:500px">
              <kendo-grid-messages noRecords="{{ 'NO-ISSUERS' | translate }}"></kendo-grid-messages>
              <kendo-grid-column class="ellipsis-text" field="name" title="{{ 'ISSUER-NAME' | translate }}"
                [width]="100">
                <ng-template kendoGridCellTemplate let-dataItem>
                  <span title="{{dataItem.issuer.name}}">{{dataItem.issuer.name}}</span>
                </ng-template>
              </kendo-grid-column>
              <kendo-grid-column class="ellipsis-text" field="name" title="{{ 'PROFILE-ID' | translate }}"
                [width]="100">
                <ng-template kendoGridCellTemplate let-dataItem>
                  <span title="{{dataItem.profileId}}">{{dataItem.profileId}}</span>
                </ng-template>
              </kendo-grid-column>
              <kendo-grid-command-column [width]="40" title="{{ 'ACTIONS' | translate }}" class="text-center">
                <ng-template kendoGridCellTemplate let-dataItem>
                  <ng-container>
                    <i class="fas fa-trash-alt fa-lg" title="{{'DELETE' | translate}}"
                      (click)="deleteUserIssuer(dataItem)" tabindex="0" (keydown.enter)="deleteUserIssuer(dataItem)"
                      (keydown.space)="deleteUserIssuer(dataItem)"></i>
                  </ng-container>
                </ng-template>
              </kendo-grid-command-column>
            </kendo-grid>
          </div>
        </ng-template>
      </kendo-tabstrip-tab>
      <kendo-tabstrip-tab title="{{ 'BILLING-ORGANIZATIONS' | translate }}" *ngIf="billingTabVisible">
        <ng-template kendoTabContent>
          <div class="p-1">
            <div class="row">
              <div class="col-1 pt-3">
                <label class="k-form-field">
                  <span class="k-text-uppercase dark" [ngClass]="{'k-disabled': !isAdmin}">
                    {{ 'ALL' | translate }}
                  </span>
                  <input type="checkbox" [indeterminate]="allBillingOrganizations.value === null"
                    formControlName="allBillingOrganizations" kendoCheckBox />
                </label>
              </div>
              <div class="col-11">
                <label for="billingOrganizations" class="k-form-field mt-0"
                  [ngClass]="{'k-disabled': allBillingOrganizations && allBillingOrganizations.value}">
                  <span class="k-text-uppercase dark">
                    {{ 'ORGANIZATIONS' | translate }}
                  </span>
                  <kendo-multiselect [data]="organizationsFiltered" formControlName="billingOrganizations"
                    class="max-height" [textField]="'name'" [filterable]="true" [valueField]="'id'"
                    (filterChange)="filterOrganizations($event)" (close)="searchTerm=''" [autoClose]="true"
                    [virtual]="virtualOrganization" [itemDisabled]="itemDisabled">
                    <ng-template kendoMultiSelectItemTemplate let-dataItem>
                      <span innerHTML="{{ dataItem.name | highlight : searchTerm }}">
                      </span>
                    </ng-template>
                  </kendo-multiselect>
                </label>
              </div>
            </div>
          </div>
        </ng-template>
      </kendo-tabstrip-tab>
      <kendo-tabstrip-tab title="{{ 'ACTIVE-ORGANIZATIONS' | translate }}"
        *ngIf="!servicesAccount.value && !isCommunityUserRole && (isAdmin || (!isAdmin && allowedOrganizations.length > 0))">
        <ng-template kendoTabContent>
          <div class="p-2">
            <button *ngIf="isAdmin" kendoButton [primary]="true" (click)="addOrganization()" type="button" class="mb-2">
              {{'ADD' | translate}}<i class="far fa-plus"></i>
            </button>
            <div formArrayName="allowedOrganizations" class="container-organizations">
              <table class="table table-hover">
                <thead>
                  <tr>
                    <th>
                      <label class="control-label text-uppercase font-weight-normal">{{ 'ORGANIZATION' | translate }}
                        *</label>
                    </th>
                    <th>
                      <label class="control-label text-uppercase font-weight-normal">{{ 'DEPARTMENT' | translate
                        }}
                      </label>
                    </th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let organization of userForm.controls.allowedOrganizations.controls; let i=index"
                    [formGroupName]="i">
                    <td style="width:50%">
                      <kendo-combobox class="w-100 {{!isAdmin ? 'k-disabled' : ''}}" formControlName="organizationId"
                        [data]="allOrganizations" [textField]="'name'" [valueField]="'id'" [valuePrimitive]="true"
                        [itemDisabled]="itemDisabled" [readonly]="!isAdmin">
                      </kendo-combobox>
                      <div class="k-tooltip k-tooltip-validation" role="alert"
                        *ngIf="userForm.controls.allowedOrganizations.controls[i].controls.organizationId.hasError('required') && 
                                       userForm.controls.allowedOrganizations.controls[i].controls.organizationId.touched">
                        {{ 'REQUIRED-ORGANIZATION' | translate }}
                      </div>
                    </td>
                    <td style="width:40%">
                      <kendo-combobox class="w-100 {{!isAdmin ? 'k-disabled' : ''}}" formControlName="departmentId"
                        [data]="getAllowedDepartments(i)" [textField]="'name'" [valueField]="'id'"
                        [valuePrimitive]="true" [itemDisabled]="itemDisabled" [readonly]="!isAdmin">
                      </kendo-combobox>
                    </td>
                    <td>
                      <a title="{{ 'DELETE' | translate }}" *ngIf="isAdmin"
                        (click)="removeOrganization(i,userForm.controls.allowedOrganizations.controls[i].controls.id.value)">
                        <i class="fas fa-fw fa-times-circle fa-delete-custom">&nbsp;</i>
                      </a>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </ng-template>
      </kendo-tabstrip-tab>
    </kendo-tabstrip>
  </form>
</div>

<ng-template #roleInfoTemplate>
  <table>
    <thead>
      <tr>
        <th style="width:30%;border-bottom: 1px solid;" class="tooltip-header">{{'ROLE'| translate}}</th>
        <th style="width:70%;border-bottom: 1px solid;" class="tooltip-header">{{'DESCRIPTION'| translate}}</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td class="tooltip-header">{{'ROLE-INFO-CARE-COORDINATOR-TITLE'| translate}}</td>
        <td>{{'ROLE-INFO-CARE-COORDINATOR-TEXT'| translate}}</td>
      </tr>
      <tr>
        <td class="tooltip-header">{{'ROLE-INFO-COMMUNITY-ADMIN-TITLE'| translate}}</td>
        <td>{{'ROLE-INFO-COMMUNITY-ADMIN-TEXT'| translate}}</td>
      </tr>
      <tr>
        <td class="tooltip-header">{{'ROLE-INFO-COMMUNITY-COORDINATOR-TITLE'| translate}}</td>
        <td>{{'ROLE-INFO-COMMUNITY-COORDINATOR-TEXT'| translate}}</td>
      </tr>
      <tr>
        <td class="tooltip-header">{{'ROLE-INFO-COMMUNITY-USER-TITLE'| translate}}</td>
        <td>{{'ROLE-INFO-COMMUNITY-USER-TEXT'| translate}}</td>
      </tr>
      <tr>
        <td class="tooltip-header">{{'ROLE-INFO-OPERATOR-TITLE'| translate}}</td>
        <td>{{'ROLE-INFO-OPERATOR-TEXT'| translate}}</td>
      </tr>
      <tr>
        <td class="tooltip-header">{{'ROLE-INFO-PROGRAM-LEAD-TITLE'| translate}}</td>
        <td>{{'ROLE-INFO-PROGRAM-LEAD-TEXT'| translate}}</td>
      </tr>
      <tr>
        <td class="tooltip-header">{{'ROLE-INFO-REFERRAL-COORDINATOR-TITLE'| translate}}</td>
        <td>{{'ROLE-INFO-REFERRAL-COORDINATOR-TEXT'| translate}}</td>
      </tr>
      <tr>
        <td class="tooltip-header">{{'ROLE-INFO-REVENUE-MANAGER-OPERATOR-TITLE'| translate}}</td>
        <td>{{'ROLE-INFO-REVENUE-MANAGER-OPERATOR-TEXT'| translate}}</td>
      </tr>
      <tr>
        <td class="tooltip-header">{{'ROLE-INFO-REVENUE-MANAGER-ANALYST-TITLE'| translate}}</td>
        <td>{{'ROLE-INFO-REVENUE-MANAGER-ANALYST-TEXT'| translate}}</td>
      </tr>
      <tr>
        <td class="tooltip-header">{{'ROLE-INFO-REVENUE-ANALYST-TITLE'| translate}}</td>
        <td>{{'ROLE-INFO-REVENUE-ANALYST-TEXT'| translate}}</td>
      </tr>
      <tr>
        <td class="tooltip-header">{{'ROLE-INFO-SYSTEM-OPERATOR-TITLE'| translate}}</td>
        <td>{{'ROLE-INFO-SYSTEM-OPERATOR-TEXT'| translate}}</td>
      </tr>
    </tbody>
  </table>
</ng-template>

<!--QRCode Dialog-->
<kendo-dialog title="{{'TWO-FACTOR-AUTH' | translate | titlecase }} - {{ 'QRCODE' | translate }}"
  *ngIf="showQRCodeDialog" (close)="showQRCodeDialog=false;" [width]="450">
  <div class="text-center">
    <img alt="{{'QRCODE' | translate}}" class="qrcode-image m-2" [src]="qrCodeImageUrl">
  </div>
  <div class="text-center">
    <a class="pointer" target="_blank" (click)="generateNewSecret()">{{'QRCODE-GENERATE' | translate}}</a>
    <div class="montserrat mb-3">{{qrCodeKey}}</div>
  </div>
  <div class="text-center">
    <i class="fa fa-info-circle"></i><span class="montserrat ml-1">{{'QRCODE-DESCRIPTION' | translate }}</span>
  </div>
  <kendo-dialog-actions>
    <button appPreventClick kendoButton (click)="showQRCodeDialog=false;" [primary]="true">{{ 'CLOSE' | translate }}
    </button>
  </kendo-dialog-actions>
</kendo-dialog>

<!--Warning message when disabling-->
<kendo-dialog title="{{ 'PLEASE-CONFIRM' | translate }}" *ngIf="showDesactivationWarning"
  (close)="desactivationWarningSave(false)" [minWidth]="250" [width]="650">
  <p>{{ 'CONFIRM-CONTINUE-SAVING' | translate }}</p>
  <div style="max-height:350px;overflow: auto;" class="k-font-weight-bold validation-error"
    innerHTML="{{desactivationWarningContent}}">
  </div>
  <kendo-dialog-actions>
    <button kendoButton (click)="desactivationWarningSave(false)">{{ 'NO' | translate }}</button>
    <button appPreventClick kendoButton (click)="desactivationWarningSave(true)" [primary]="true">{{ 'YES' | translate
      }}
    </button>
  </kendo-dialog-actions>
</kendo-dialog>